export const websocketsSelector = (state) => state.websockets;
